




import {Component, Prop, Vue} from "vue-property-decorator";
import {CustomerStore} from "../../store";

@Component({
    name: "CustomerLabel"
})
export default class extends Vue {
    @Prop({ required: true, type: String })
    readonly id!: string;

    get label() {
        return `${CustomerStore.data[this.id]?.customerCode} - ${CustomerStore.data[this.id]?.fullName}`;
    }
}
